import { createSlice } from "@reduxjs/toolkit";
import { CustomerResponseDto } from "../../shared/dtos/customer/CustomerResponseDto";
import { CustomerSummaryDto } from "../../shared/dtos/customer/CustomerSummaryDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

const customerSlice = createSlice({
  name: "customer",
  initialState: getInitialCrudState<CustomerResponseDto, CustomerSummaryDto>(),
  reducers: {
    ...generateCrudReducers<CustomerResponseDto, CustomerSummaryDto>(),
  },
});

export const customerActions = customerSlice.actions;
export default customerSlice.reducer;
